//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// Not Found Page - Notifies the user that they attempted to access a page that
// could not be found.
//

// Libs
import React from 'react';
import { Link } from 'react-router-dom';

// Components
import { Button, FlexLayout } from '@nutanix-ui/prism-reactjs';

import { PATH_URL } from '../constant';

// ------------
// NotFoundPage
// ------------

export default class NotFoundPage extends React.PureComponent {
    render() {
        return (
            <FlexLayout flexDirection="column" alignItems="center" justifyContent="center">
                <h1>Errors.pageNotFound</h1>
                <Link to={PATH_URL.DEFAULT} replace={true}>
                    <Button>{'Errors.backToSafety'}</Button>
                </Link>
            </FlexLayout>
        );
    }
}
